<script>
import axios from 'axios';
import { jwtDecode } from "jwt-decode";
const apiUrl = `${process.env.VUE_APP_API_URL}`;
const utilsService = {
  async checkUrl(url) {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = url;

      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
    });
  },

  setLogin(token) {
    localStorage.setItem('user-session', token);
    const decoded = jwtDecode(token);
    localStorage.setItem('user-role', decoded.rol);
    localStorage.setItem('user-id', decoded.userid);
    localStorage.setItem('user-name', decoded.name);

    const maxAge = Math.max(0, (decoded.exp || 0) - Math.floor(Date.now() / 1000));
    const secure = location.protocol === 'https:' ? '; secure' : '';
    const domainAttr = location.hostname.endsWith('inexlink.com') ? '; domain=.inexlink.com' : '';
    document.cookie = `inexlink_session=${token}; path=/; max-age=${maxAge}; samesite=lax${secure}${domainAttr}`;

    return token;
  },

  getToken() {
    const token = localStorage.getItem('user-session');
    if (!token) this.logout();
    return token;
  },

  getRol() {
    const userRole = localStorage.getItem('user-role') || '';
    return userRole.trim().toLowerCase(); // <- ayuda si llega con mayúsculas o espacios
  },

  // Perfiles que solo pueden consultar: ven todas las pantallas pero no crean,
  // modifican, eliminan ni ejecutan procesos. Se refleja en el backend con la
  // política "Escritura" (ver materialesapi/Program.cs).
  ROLES_SOLO_LECTURA: ['visita'],

  esSoloLectura() {
    return this.ROLES_SOLO_LECTURA.includes(this.getRol());
  },

  puedeEscribir() {
    return !this.esSoloLectura();
  },

  getUserInfo() {
    const userInfo = {
      rol: localStorage.getItem('user-role'),
      id: localStorage.getItem('user-id'),
      username: localStorage.getItem('user-name')
    };
    return userInfo;
  },
  
  getUsuarioId() {
    const id = localStorage.getItem('idUsuario');
    return id ? Number(id) : null;
  },

  logout() {
    this._clearSharedCookie();
    localStorage.clear();
    window.location.href = '/login';
  },

  _readSharedCookie() {
    const match = document.cookie.split('; ').find(c => c.indexOf('inexlink_session=') === 0);
    return match ? match.substring('inexlink_session='.length) : '';
  },

  _clearSharedCookie() {
    const domainAttr = location.hostname.endsWith('inexlink.com') ? '; domain=.inexlink.com' : '';
    document.cookie = `inexlink_session=; path=/; max-age=0; samesite=lax${domainAttr}`;
  },

  _clearSession() {
    // Borra solo las claves de sesión, preservando preferencias de la app (empresa-activa, etc.)
    ['user-session', 'user-role', 'user-id', 'user-name'].forEach(k => localStorage.removeItem(k));
  },

  syncSessionFromShared() {
    if (!location.hostname.endsWith('inexlink.com') && location.hostname !== 'localhost') {
      return 'noop';
    }
    const localToken = localStorage.getItem('user-session');
    const shared = this._readSharedCookie();

    if (shared && shared !== localToken) {
      try {
        const decoded = jwtDecode(shared);
        if (decoded.exp && decoded.exp > Date.now() / 1000) {
          localStorage.setItem('user-session', shared);
          localStorage.setItem('user-role', decoded.rol || '');
          localStorage.setItem('user-id', decoded.userid || '');
          localStorage.setItem('user-name', decoded.name || '');
          return 'adopted';
        }
      } catch (e) {}
      this._clearSession();
      return 'cleared';
    }

    if (!shared && localToken) {
      this._clearSession();
      return 'cleared';
    }

    return 'noop';
  },


  async refreshLanguage() {
    try {
      const lan = localStorage.getItem('language') || "es";
      const token = this.getToken();
      const response = await axios.get(`${apiUrl}/api/auth/refreshLocate/${lan}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      return utilsService.setLogin(response.data.token);
    } catch (error) {
      console.error('Error al enviar el formulario', error);
    }
  },
  formatMiles(value) {
    if (!value) return '';
    const rawValue = value.toString().replace(/\D/g, '');
    return rawValue.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  },

  parseMiles(value) {
    if (!value) return '';
    return value.toString().replace(/\./g, '');
  },

  getFormattedValue(field, form) {
    return this.formatMiles(form[field]);
  },

  onInput(field, form, event) {
    if (event) {
      const cleanValue = event.replace(/\D/g, '');
      form[field] = this.parseMiles(cleanValue);
    }
  },

  formatMilesWithComma(value) {
    if (!value) return '';
    const [integerPart, decimalPart] = value.toString().split(',');
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return decimalPart !== undefined
      ? `${formattedInteger},${decimalPart}`
      : formattedInteger;
  },

  parseMilesWithComma(value) {
    if (!value) return '';
    let cleanValue = value.toString().replace(/[^0-9,]/g, '');
    const [integerPart, decimalPart] = cleanValue.split(',');
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return decimalPart !== undefined ? `${formattedInteger},${decimalPart}` : formattedInteger;
  },

  getFormattedDecimal(field, form) {
    return this.formatMilesWithComma(form[field]);
  },

  onInputDecimal(field, form, event) {
    const cleanValue = event.replace(/[^0-9,]/g, '');
    form[field] = this.parseMilesWithComma(cleanValue);

  },
};

export default utilsService;
</script>